import _ from 'lodash';

export default function reducer(
  state = {
    Count: {},
    List: [],
    FormActive: 'List',
    Selected: {},
    SelectedId: [],
    Filter: {},
    Loading: 'RETRIEVING',
    CommentToEdit: '',
    DocumentList: [],
    Actions: {
      add: {},
      reply: {},
      update: {},
    },
    ConversationCount: 0,
  },
  action
) {
  switch (action.type) {
    case 'ADD_COMMENT_LIST': {
      const { List } = { ...state };
      const updatedList = _.uniqBy(List.concat(action.list), 'id');

      return {
        ...state,
        List: updatedList,
        ...(typeof action.count !== 'undefined' ? { Count: action.count } : state.Count),
      };
    }
    case 'SET_COMMENT_LIST': {
      return {
        ...state,
        List: action.list,
        ...(typeof action.count !== 'undefined' ? { Count: action.count } : {}),
      };
    }
    case 'SET_COMMENT_FORM_ACTIVE': {
      return { ...state, FormActive: action.FormActive };
    }
    case 'SET_COMMENT_SELECTED': {
      return { ...state, Selected: action.Selected };
    }
    case 'SET_COMMENT_ID': {
      return { ...state, SelectedId: action.SelectedId };
    }
    case 'SET_COMMENT_DOCUMENT_LIST': {
      return { ...state, DocumentList: action.list };
    }
    case 'SET_COMMENT_STATUS': {
      let List = state.List.map((e, i) => {
        if (e.id === action.record.id) {
          e.Active = action.record.status;
          return e;
        } else {
          return e;
        }
      });
      return { ...state, List: List };
    }
    case 'SET_COMMENT_FILTER': {
      const { Filter } = { ...state };
      const updatedFilter = _.merge({}, _.omit(Filter, action.name), action.filter);
      return { ...state, Filter: updatedFilter };
    }
    //UPDATE
    case 'UPDATE_COMMENT_LIST': {
      const { List } = { ...state };
      List.unshift(action.comment);
      return { ...state, List };
    }

    case 'SET_NEW_COMMENT_LIST': {
      return {
        ...state,
        List: action.list,
      };
    }

    //REMOVE
    case 'REMOVE_DELETED_COMMENT_LIST': {
      let tempList = [];
      action.list.map((e, i) => {
        if (action.id !== e.id) {
          tempList.push(e);
        }
      });
      return { ...state, List: tempList };
    }
    case 'SET_COMMENT_LOADING': {
      return { ...state, Loading: typeof action.Loading !== 'undefined' ? action.Loading : '' };
    }
    case 'CLEAR_COMMENT': {
      return { ...state, List: [], Count: {} };
    }
    case 'SET_COMMENT_TO_EDIT': {
      return { ...state, CommentToEdit: action.comment };
    }
    case 'SET_CONVERSATION_COUNT': {
      return { ...state, ConversationCount: action.count };
    }
    case 'DECREMENT_CONVERSATION_COUNT': {
      return { ...state, ConversationCount: state.ConversationCount - 1 };
    }

    case 'SET_ACTION_COMMENTS': {
      return {
        ...state,
        Actions: {
          ...state.Actions,
          [action.action]: action.data,
        },
      };
    }

    case 'CLEAR_ACTION_COMMENTS': {
      return {
        ...state,
        Actions: {
          add: {},
          reply: {},
          update: {},
        },
      };
    }

    default:
      return state;
  }
}
